import {useContext} from 'react';

import {LoadingPlaceholder} from 'src/components';
import {WorkspaceContext} from 'src/context';

import './styles.css';

const NO_SELECTED_WORKSPACE_DISPLAY_TEXT = '[No Workspace Selected]';

export const WorkspaceTitle = () => {
  const {currentWorkspace, loading} = useContext(WorkspaceContext);


  const currentWorkspaceText = currentWorkspace ? currentWorkspace.displayName : NO_SELECTED_WORKSPACE_DISPLAY_TEXT;

  return (
    <span className='WorkspaceTitle' title={currentWorkspaceText}>
      {loading ? (
                <LoadingPlaceholder plaintext />
              ) : (
                currentWorkspaceText
              )}
    </span>
  );
};
